import { FC } from 'react'
import { Select, SelectOnChangeEvent } from '@dtx-company/design-system/src'

export const NumberDropdown: FC<{
  minNumber?: number
  maxNumber: number
  currentNumber: number
  setNumber: (i: number) => void
}> = ({ minNumber = 0, maxNumber, currentNumber, setNumber }) => {
  const options = Array.from({ length: maxNumber - minNumber + 1 }, (_, index) => {
    const value = minNumber + index
    return { label: String(value), value }
  })

  const handleChange = (e: SelectOnChangeEvent): void => {
    setNumber(Number(e.target.value))
  }

  return (
    <Select
      label=""
      hiddenLabel
      value={currentNumber}
      onChange={handleChange}
      options={options}
      sx={{
        minWidth: 'max-content'
      }}
    />
  )
}
